import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, IconButton, Paper, Typography, Grid,
    TextField, Button, FormControl, InputLabel, Select, MenuItem, DialogActions, FormControlLabel, Checkbox,
    Grid2, Box
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import SaveIcon from '@mui/icons-material/Save';
import { Delete } from '@mui/icons-material';
import TablaPreguntas from '../../components/TablaPreguntas';
import { myApi } from '../../../../config/axiosConfig';
import Swal from 'sweetalert2';
import CircleOverlay from '../../components/CircleOverlay';
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/Info";
import ModalMatriz from './ModalMatriz';
import CircleItem from '../../components/CircleItem';

function ModalAgregarPregunta({ open, onClose, temas, formularios, refresh }) {
    const [circleCoords, setCircleCoords] = useState(null); // Guarda el círculo actual
    const [showForm, setShowForm] = useState(false); // Muestra el form de pregunta
    const [isLocked, setIsLocked] = useState(false);
    const [preguntas, setPreguntas] = useState([]);
    const [preguntasCompletas, setPreguntasCompletas] = useState([]);
    const [temaSeleccionado, setTemaSeleccionado] = useState(null);

    const [formularioSeleccionado, setFormularioSeleccionado] = useState(null);
    const [temasFormulario, setTemasFormulario] = useState([]);

    //Modo de edicion de preguntas
    const [modoEdicion, setModoEdicion] = useState(false);
    const [preguntaEditando, setPreguntaEditando] = useState(null);

    const [circles, setCircles] = useState([]);

    //#region FUNCIONES de TEMA DE TIPO MATRIZ
    const [temaTipoMatriz, setTemaTipoMatriz] = useState(false);
    const [openModalMatriz, setOpenModalMatriz] = useState(false);
    const [itemsMatriz, setItemsMatriz] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [editingItem, setEditingItem] = useState(null);
    const [showValidacionMatriz, setShowValidacionMatriz] = useState(false);

    const [erroresItemsMatriz, setErroresItemsMatriz] = useState([]);

    useEffect(() => {
        if (showValidacionMatriz) {
            const timer = setTimeout(() => {
                setShowValidacionMatriz(false);
                setErroresItemsMatriz([]); // limpia también los errores
            }, 5000); // 5000ms = 5 segundos

            return () => clearTimeout(timer);
        }
    }, [showValidacionMatriz])

    const handleDeleteItem = (id) => {
        setItemsMatriz((prevItems) => prevItems.filter((item) => item.id !== id));

        // Si el item eliminado era el seleccionado, lo deseleccionamos
        if (selectedItem === id) {
            setSelectedItem(null);
        }
    };

    const handleEditItem = (item) => {
        setEditingItem(item);
        setOpenModalMatriz(true);
    };

    const handleClickItem = (itemSelected) => {
        setSelectedItem(itemSelected);
        // Buscar si ya existe una pregunta vinculada a este item
        const preguntaAsociada = preguntas.find(p => p.id_item_matriz === itemSelected);

        if (preguntaAsociada) {
            setPreguntaEditando(preguntaAsociada);
            setModoEdicion(true);
        } else {
            setPreguntaEditando(null);
            setModoEdicion(false);
        }

        setShowForm(true);
    };

    //#endregion

    const hayPendientes = () => {
        if (temaSeleccionado?.tipo_tema === 'matriz') {
            const preguntasTema = preguntasCompletas.filter(
                p => p.id_tema === temaSeleccionado.id_Tema
            );
            const itemsSinPregunta = itemsMatriz.filter(
                item => !preguntasTema.some(p => p.id_item_matriz === item.id)
            );
            return itemsSinPregunta.length > 0;
        } else {
            const preguntasDelTema = preguntasCompletas.filter(p => p.id_tema === temaSeleccionado?.id_Tema);
            const puntosDelTema = circles.filter(c => c.id_tema === temaSeleccionado?.id_Tema);
            const puntosConPregunta = preguntasDelTema.map(p => `${p.x}-${p.y}`);
            const puntosSinPregunta = puntosDelTema.filter(c =>
                !puntosConPregunta.includes(`${c.x}-${c.y}`)
            );
            return puntosSinPregunta.length > 0;
        }
    };


    const handleCircleCreated = (coords) => {
        if (isLocked) return;

        const label = (circles.length + 1).toString();
        const newCircle = { ...coords, label, id_tema: temaSeleccionado?.id_Tema };
        setCircleCoords(coords);
        setCircles([...circles, newCircle]);
        setShowForm(true);
        setIsLocked(true);
    };

    const handleSubmitPregunta = async (values, { resetForm }) => {
        const esMatriz = temaSeleccionado?.tipo_tema === 'matriz';

        try {
            const id_pregunta =
                modoEdicion && preguntaEditando
                    ? preguntaEditando.id_pregunta
                    : Math.random(); // usa tu generador de ids preferido

            // Objeto base común a ambos casos
            const objPreguntaBase = {
                ...values,
                id_pregunta,
                id_tema: temaSeleccionado?.id_Tema || null,
                nombre_tema: temaSeleccionado?.nombre_tema || '',
                opciones_respuesta: values.opciones_respuesta,
                obligatorio: values.obligatorio,
                permitir_nota: values.permitir_nota,
                permitir_foto: values.permitir_foto,
                tipo_pregunta: values.tipo_pregunta,
                id_formulario: formularioSeleccionado?.id_formulario,
                id_item_matriz: esMatriz ? selectedItem : null,
            };

            let updatedPreguntas = [];
            let updatedPreguntasCompletas = [];

            if (esMatriz) {
                // ---------- CASO MATRIZ: NO GUARDES COORDENADAS ----------
                if (modoEdicion && preguntaEditando) {
                    updatedPreguntas = preguntas.map(p =>
                        p.id_pregunta === id_pregunta ? objPreguntaBase : p
                    );
                    updatedPreguntasCompletas = preguntasCompletas.map(p =>
                        p.id_pregunta === id_pregunta ? objPreguntaBase : p
                    );
                } else {
                    updatedPreguntas = [...preguntas, objPreguntaBase];
                    updatedPreguntasCompletas = [...preguntasCompletas, objPreguntaBase];
                }



            } else {
                // ---------- CASO NORMAL (con círculos) ----------
                const objPreguntaCirculo = {
                    ...objPreguntaBase,
                    x: circleCoords.x,
                    y: circleCoords.y,
                    radio: circleCoords.radius || 10,
                };

                if (modoEdicion && preguntaEditando) {
                    updatedPreguntas = preguntas.map(p =>
                        p.id_pregunta === id_pregunta ? objPreguntaBase : p
                    );

                    updatedPreguntasCompletas = preguntasCompletas.map(p =>
                        p.id_pregunta === id_pregunta ? objPreguntaCirculo : p
                    );
                } else {
                    updatedPreguntas = [...preguntas, objPreguntaBase];
                    updatedPreguntasCompletas = [...preguntasCompletas, objPreguntaCirculo];
                }
            }

            setPreguntas(updatedPreguntas);
            setPreguntasCompletas(updatedPreguntasCompletas);

            resetForm();
            setShowForm(false);

            // Solo resetea lo relacionado a círculos cuando NO es matriz
            if (!esMatriz) {
                setIsLocked(false);
                setCircleCoords(null);
            }

            setModoEdicion(false);
            setPreguntaEditando(null);
        } catch (err) {
            console.error(err);
            Swal.fire({ icon: 'error', title: 'Error al guardar la pregunta' });
        }
    };

    const handleSubmitFormulario = async () => {
        try {
            let validacionMatriz = true;
            setErroresItemsMatriz([]); // Limpia errores anteriores

            if (temaSeleccionado?.tipo_tema === 'matriz') {
                const preguntasTemaMatriz = preguntasCompletas.filter(
                    p => p.id_tema === temaSeleccionado.id_Tema
                );

                const itemsSinPregunta = itemsMatriz.filter(
                    item => !preguntasTemaMatriz.some(p => p.id_item_matriz === item.id)
                );

                if (itemsSinPregunta.length > 0) {
                    validacionMatriz = false;
                    setShowValidacionMatriz(true);
                    setErroresItemsMatriz(itemsSinPregunta.map(item => item.label || `Item ${item.id}`));
                    console.warn('Faltan preguntas para los siguientes items:', itemsSinPregunta);
                }

            } else {
                const preguntasDelTema = preguntasCompletas.filter(p => p.id_tema === temaSeleccionado.id_Tema);
                const puntosDelTema = circles.filter(c => c.id_tema === temaSeleccionado.id_Tema);

                const puntosConPregunta = preguntasDelTema.map(p => `${p.x}-${p.y}`);
                const puntosSinPregunta = puntosDelTema.filter(c =>
                    !puntosConPregunta.includes(`${c.x}-${c.y}`)
                );

                if (puntosSinPregunta.length > 0) {
                    validacionMatriz = false;
                    setShowValidacionMatriz(true);

                    setErroresItemsMatriz([
                        `El tema "${temaSeleccionado.nombre_tema}" tiene ${puntosSinPregunta.length} punto(s) sin pregunta asignada.`
                    ]);

                    console.warn(`Tema "${temaSeleccionado.nombre_tema}" tiene puntos sin pregunta:`, puntosSinPregunta);
                } else if (preguntasDelTema.length === 0) {
                    validacionMatriz = false;
                    setShowValidacionMatriz(true);

                    setErroresItemsMatriz([
                        `El tema "${temaSeleccionado.nombre_tema}" no tiene ninguna pregunta.`
                    ]);

                    console.warn(`Tema "${temaSeleccionado.nombre_tema}" no tiene preguntas.`);
                }
            }

            if (validacionMatriz) {
                const formData = new FormData();

                // Preguntas
                formData.append("preguntas", JSON.stringify(preguntasCompletas));

                // Items como JSON
                const itemsLimpios = itemsMatriz.map((item) => ({
                    id: item.id,
                    label: item.label,
                    imageFieldKey: item.imageFile ? `file_item_${item.id}` : null,
                    imageUrl: (!item.imageFile && item.image?.startsWith('http')) ? item.image : '',
                    id_tema: temaSeleccionado?.id_Tema || ''
                }));
                formData.append("items", JSON.stringify(itemsLimpios));

                // Archivos asociados
                itemsMatriz.forEach((item) => {
                    if (item.imageFile) {
                        formData.append(`file_item_${item.id}`, item.imageFile);
                    }
                });

                // Enviar todo en un único POST
                const response = await myApi.post('/inspeccion/preguntas/insertPreguntas', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                if (response.data.success) {
                    handleClose();
                    await refresh();
                }
            }

        } catch (error) {
            console.error('Error al guardar las preguntas:', error);
        }
    };

    const handleClose = () => {
        setPreguntas([]);
        setPreguntasCompletas([]);
        setTemaSeleccionado(null);
        setTemasFormulario([]);
        setTemaSeleccionado(null);
        setFormularioSeleccionado(null);
        setIsLocked(false);
        setShowForm(false);
        setCircles([]);
        onClose();
        setOpenModalMatriz(false);
        setItemsMatriz([]);
        setErroresItemsMatriz([]);
    }

    const opcionesTipoPregunta = [
        { value: 'texto', label: 'Texto' },
        { value: 'numerica', label: 'Número' },
        { value: 'seleccion_unica', label: 'Opción única' },
        { value: 'seleccion_multiple', label: 'Opción múltiple' },
        { value: 'fecha', label: 'Fecha' },
    ];

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth>
            <DialogTitle>
                Agregar Preguntas
                <IconButton onClick={handleClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <Close />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Paper sx={{ p: 2 }}>
                            <Typography variant="h5">Puntos de inspección</Typography>
                            <hr />
                            { /* estado de tipo matriz */}
                            {!temaTipoMatriz && (
                                <CircleOverlay
                                    onCircleCreated={handleCircleCreated}
                                    disabled={isLocked}
                                    imagen={temaSeleccionado?.imagen_url}
                                    circles={circles.filter(c => c.id_tema === temaSeleccionado?.id_Tema)}
                                    onCirclesChange={(newCircles) => {
                                        // Actualizamos solo los círculos del tema actual
                                        const otrosTemas = circles.filter(c => c.id_tema !== temaSeleccionado?.id_Tema);
                                        const nuevosCirculos = newCircles.map(c => ({ ...c, id_tema: temaSeleccionado?.id_Tema }));
                                        setCircles([...otrosTemas, ...nuevosCirculos]);
                                    }}
                                />
                            )}
                            { /* codigo que muestra los items de la matriz */}
                            {itemsMatriz.length > 0 && temaTipoMatriz && (
                                <Grid2 container spacing={2}>
                                    {itemsMatriz.map((item, index) => (
                                        <Grid2 item xs={12} sm={6} md={4} lg={3} key={item.id || index}>
                                            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                                                {/* Componente que muestra el item */}
                                                <CircleItem
                                                    image={item.image}
                                                    label={item.label}
                                                    size={100}
                                                    onClick={() => handleClickItem(item.id)}
                                                    selectedItem={selectedItem === item.id}
                                                />
                                                {/* Botón para editar */}
                                                <IconButton
                                                    size="small"
                                                    color='warning'
                                                    sx={{
                                                        position: 'absolute',
                                                        top: -8,
                                                        left: -8,
                                                        backgroundColor: 'rgba(255,255,255,0.8)',
                                                        '&:hover': { backgroundColor: 'rgba(255,255,255,1)' }
                                                    }}
                                                    onClick={() => handleEditItem(item)}
                                                >
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                                {/* Botón para eliminar */}
                                                <IconButton
                                                    size="small"
                                                    color='error'
                                                    sx={{
                                                        position: 'absolute',
                                                        top: -8,
                                                        right: -8,
                                                        backgroundColor: 'rgba(255,255,255,0.8)',
                                                        '&:hover': { backgroundColor: 'rgba(255,255,255,1)' }
                                                    }}
                                                    onClick={() => handleDeleteItem(item.id)}
                                                >
                                                    <Delete fontSize="small" />
                                                </IconButton>
                                            </Box>
                                        </Grid2>
                                    ))}
                                </Grid2>
                            )}
                            {erroresItemsMatriz.length > 0 && (
                                <Box sx={{ mt: 2 }}>
                                    <Typography variant="body1" color="error" fontWeight="bold">
                                        Falta asignar preguntas en:
                                    </Typography>
                                    <ul>
                                        {erroresItemsMatriz.map((item, idx) => (
                                            <li key={idx}>
                                                <Typography variant="body2" color="error">{item}</Typography>
                                            </li>
                                        ))}
                                    </ul>
                                </Box>
                            )}
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper sx={{ p: 2 }}>
                            <FormControl fullWidth sx={{ mb: 2 }}>
                                <InputLabel id="formulario-label">Formulario</InputLabel>
                                <Select
                                    labelId="formulario-label"
                                    value={formularioSeleccionado?.id_formulario || ''}
                                    label="Formulario"
                                    onChange={(e) => {
                                        const id = e.target.value;
                                        const formulario = formularios.find(f => f.id_formulario === id);

                                        if (formulario) {
                                            // Filtrar temas válidos directamente
                                            const temasValidos = (formulario.temas || []).filter(
                                                t => t.id_Tema !== null && t.nombre_tema !== null
                                            );

                                            setFormularioSeleccionado(formulario);
                                            setTemasFormulario(temasValidos);
                                            setTemaSeleccionado(null);
                                        } else {
                                            setFormularioSeleccionado(null);
                                            setTemasFormulario([]);
                                            setTemaSeleccionado(null);
                                        }
                                    }}
                                >
                                    {formularios.map((f) => (
                                        <MenuItem key={f.id_formulario} value={f.id_formulario}>
                                            {f.nombre_formulario}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth sx={{ mb: 2 }}>
                                <InputLabel id="tema-label">Tema</InputLabel>
                                <Select
                                    labelId="tema-label"
                                    value={temaSeleccionado?.id_Tema || ''}
                                    label="Tema"
                                    onChange={(e) => {
                                        if (hayPendientes()) {
                                            console.warn("No puedes cambiar de tema hasta agregar la pregunta.");
                                            setShowValidacionMatriz(true);
                                            setErroresItemsMatriz([
                                                "Debes asignar una pregunta antes de cambiar de tema."
                                            ]);
                                            return; // Salimos y no cambiamos de tema
                                        }
                                        const id = e.target.value;
                                        const tema = temasFormulario.find(t => t.id_Tema.toString() === id.toString());

                                        setTemaSeleccionado(tema || null);
                                        setShowForm(false);
                                        setPreguntaEditando(null);
                                        setSelectedItem(null);
                                        setEditingItem(null);

                                        if (!tema) {
                                            setTemaTipoMatriz(false);
                                            setIsLocked(false);
                                            setCircleCoords(null);
                                            return;
                                        }

                                        // Si es tipo matriz
                                        if (tema.tipo_tema === 'matriz') {
                                            setTemaTipoMatriz(true);
                                            setIsLocked(false);  // En matriz no se bloquea por círculos
                                            setCircleCoords(null);
                                            return;
                                        }

                                        // Si es tema normal con círculos
                                        setTemaTipoMatriz(false);

                                        const circulosTema = circles.filter(c => c.id_tema === tema.id_Tema);
                                        const preguntasTema = preguntasCompletas.filter(p => p.id_tema === tema.id_Tema);

                                        const coordenadasConPregunta = preguntasTema.map(p => `${p.x}-${p.y}`);
                                        const circuloSinPregunta = circulosTema.find(c =>
                                            !coordenadasConPregunta.includes(`${c.x}-${c.y}`)
                                        );

                                        if (circuloSinPregunta) {
                                            // Hay un círculo pendiente: lo recuperamos
                                            setCircleCoords(circuloSinPregunta);
                                            setIsLocked(true);
                                            setShowForm(true);
                                        } else {
                                            // No hay pendientes
                                            setCircleCoords(null);
                                            setIsLocked(false);
                                            setShowForm(false);
                                        }
                                    }}
                                >
                                    {temasFormulario.map((t) => (
                                        <MenuItem key={t.id_Tema} value={t.id_Tema}>
                                            {t.nombre_tema}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {showForm && (
                                <>
                                    <hr />
                                    <Grid2 container spacing={2} sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', width: '100%' }}>
                                        <Grid2 size={{ xs: 6, md: 6 }}>
                                            <Typography variant="h5">Crear Pregunta</Typography>
                                        </Grid2>
                                        <Grid2 size={{ xs: 6, md: 6 }} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <IconButton onClick={() => {
                                                setShowForm(false)
                                                setSelectedItem(null)
                                            }} >
                                                <Close />
                                            </IconButton>
                                        </Grid2>

                                    </Grid2>

                                    <Formik
                                        enableReinitialize
                                        initialValues={{
                                            texto_pregunta: preguntaEditando?.texto_pregunta || '',
                                            tipo_pregunta: preguntaEditando?.tipo_pregunta || 'texto',
                                            respuestas: preguntaEditando?.opciones_respuesta?.split('|') || [''],
                                            respuestasCorrectas: preguntaEditando?.respuestas_correctas
                                                ? preguntaEditando.respuestas_correctas.split('|') // convierte a array de strings
                                                : [],
                                            obligatorio: preguntaEditando?.obligatorio || false,
                                            permitir_nota: preguntaEditando?.permitir_nota || false,
                                            permitir_foto: preguntaEditando?.permitir_foto || false,
                                        }}
                                        validationSchema={Yup.object({
                                            texto_pregunta: Yup.string().required('Escribe la pregunta'),
                                            respuestas: Yup.lazy((value, { parent }) => {
                                                const tipo = parent.tipo_pregunta;

                                                // Si es texto, numerica o fecha, no validamos respuestas
                                                if (['texto', 'numerica', 'fecha'].includes(tipo)) {
                                                    return Yup.array().notRequired();
                                                }

                                                // En otros casos, respuestas son obligatorias
                                                return Yup.array()
                                                    .of(Yup.string().trim().required('La respuesta no puede estar vacía'))
                                                    .min(1, 'Debe agregar al menos una respuesta');
                                            }),
                                            respuestasCorrectas: Yup.lazy((value, { parent }) => {
                                                const tipo = parent.tipo_pregunta;

                                                if (tipo === 'seleccion_unica' || tipo === 'seleccion_multiple') {
                                                    return Yup.array()
                                                        .of(Yup.string())
                                                        .min(1, 'Debes marcar al menos una respuesta como correcta');
                                                }

                                                return Yup.array().notRequired(); // default para otros tipos
                                            }),

                                        })}
                                        onSubmit={(values, { resetForm }) => {
                                            // Combina respuestas en un string separado por "|"
                                            const formData = {
                                                ...values,
                                                opciones_respuesta: values.respuestas
                                                    .map(r => r.trim())
                                                    .filter(r => r !== '')
                                                    .join('|'),
                                                respuestas_correctas: values.respuestasCorrectas.join('|')
                                            };
                                            handleSubmitPregunta(formData, { resetForm });
                                        }}
                                    >
                                        {({ errors, touched, values, setFieldValue }) => (
                                            <Form autoComplete='off'>
                                                <Field
                                                    as={TextField}
                                                    name="texto_pregunta"
                                                    label="Pregunta"
                                                    fullWidth
                                                    autoComplete="off"
                                                    error={touched.texto_pregunta && !!errors.texto_pregunta}
                                                    helperText={touched.texto_pregunta && errors.texto_pregunta}
                                                    sx={{ mb: 2 }}
                                                />

                                                {/* Tipo de pregunta */}
                                                <Typography variant="subtitle1" sx={{ mt: 2 }}>
                                                    Tipo de pregunta
                                                </Typography>
                                                <Field
                                                    as={Select}
                                                    name="tipo_pregunta"
                                                    fullWidth
                                                    error={touched.tipo_pregunta && !!errors.tipo_pregunta}
                                                    helperText={touched.tipo_pregunta && errors.tipo_pregunta}
                                                    sx={{ mb: 2 }}
                                                >
                                                    {opcionesTipoPregunta.map((op) => (
                                                        <MenuItem key={op.value} value={op.value}>
                                                            {op.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>

                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={values.obligatorio}
                                                            onChange={(e) => {
                                                                setFieldValue('obligatorio', e.target.checked);
                                                            }}
                                                        />
                                                    }
                                                    label="Es obligatorio"
                                                />
                                                {/* checbox para permitir nota */}
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={values.permitir_nota}
                                                            onChange={(e) => {
                                                                setFieldValue('permitir_nota', e.target.checked);
                                                            }}
                                                        />
                                                    }
                                                    label="Permitir nota"
                                                />

                                                {/* checkbox para permitir foto*/}
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={values.permitir_foto}
                                                            onChange={(e) => {
                                                                setFieldValue('permitir_foto', e.target.checked);
                                                            }}
                                                        />
                                                    }
                                                    label="Permitir Foto"
                                                />
                                                <Typography variant="subtitle1" sx={{ mt: 2 }}>
                                                    Respuestas posibles
                                                </Typography>

                                                {values.respuestas.map((respuesta, index) => (
                                                    <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                        <TextField
                                                            value={respuesta}
                                                            onChange={(e) => {
                                                                const nuevas = [...values.respuestas];
                                                                nuevas[index] = e.target.value;
                                                                setFieldValue('respuestas', nuevas);
                                                            }}
                                                            fullWidth
                                                            placeholder={`Respuesta ${index + 1}`}
                                                            sx={{ mb: 1 }}
                                                            error={Boolean(touched.respuestas?.[index] && errors.respuestas?.[index])}
                                                            helperText={touched.respuestas?.[index] && errors.respuestas?.[index]}
                                                        />
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={values.respuestasCorrectas.includes(index.toString())}
                                                                    onChange={(e) => {
                                                                        const current = [...values.respuestasCorrectas];
                                                                        if (e.target.checked) {
                                                                            current.push(index.toString());
                                                                        } else {
                                                                            const idx = current.indexOf(index.toString());
                                                                            if (idx > -1) current.splice(idx, 1);
                                                                        }
                                                                        setFieldValue('respuestasCorrectas', current);
                                                                    }}
                                                                />
                                                            }
                                                            label="Correcta"
                                                        />
                                                        <IconButton
                                                            onClick={() => {
                                                                const nuevas = values.respuestas.filter((_, i) => i !== index);
                                                                setFieldValue('respuestas', nuevas);
                                                                // Eliminar también del array de respuestasCorrectas si estaba seleccionada
                                                                setFieldValue('respuestasCorrectas', values.respuestasCorrectas.filter(r => r !== index.toString()));
                                                            }}
                                                        >
                                                            <Delete />
                                                        </IconButton>
                                                    </div>
                                                ))}
                                                {touched.respuestasCorrectas && errors.respuestasCorrectas && (
                                                    <Typography variant="body2" color="error" sx={{ mt: -1, mb: 1 }}>
                                                        {errors.respuestasCorrectas}
                                                    </Typography>
                                                )}

                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    onClick={() => setFieldValue('respuestas', [...values.respuestas, ''])}
                                                    sx={{ mb: 2 }}
                                                >
                                                    Agregar Respuesta
                                                </Button>

                                                <br />
                                                <Button type="submit" variant="contained">Guardar Pregunta</Button>
                                            </Form>
                                        )}
                                    </Formik>
                                </>
                            )}

                            { /* boton para agregar item a la matriz */}
                            {temaTipoMatriz && (
                                <>
                                    <Button variant="contained" startIcon={<AddIcon />} onClick={() => {
                                        const preguntasTema = preguntasCompletas.filter(
                                            p => p.id_tema === temaSeleccionado?.id_Tema
                                        );

                                        const itemsSinPregunta = itemsMatriz.filter(
                                            item => !preguntasTema.some(p => p.id_item_matriz === item.id)
                                        );

                                        if (itemsSinPregunta.length > 0) {
                                            setShowValidacionMatriz(true);
                                            setErroresItemsMatriz([
                                                `Debes asignar una pregunta al item "${itemsSinPregunta[0].label}" antes de agregar otro.`
                                            ]);
                                            return;
                                        }

                                        // Si no hay pendientes, permitir agregar nuevo
                                        setEditingItem(null);
                                        setOpenModalMatriz(true);
                                    }} sx={{ mt: 2 }}>
                                        Nuevo Item
                                    </Button>
                                </>

                            )}

                            {preguntas.length > 0 && (
                                <TablaPreguntas
                                    preguntas={preguntas}
                                    onEditar={(pregunta) => {
                                        setPreguntaEditando(pregunta);
                                        setShowForm(true);
                                        setModoEdicion(true);

                                        if (pregunta.x && pregunta.y) {
                                            setCircleCoords({ x: pregunta.x, y: pregunta.y, radius: pregunta.radio });
                                            setIsLocked(true);
                                        }

                                        // Asegura también que se cargue su tema
                                        const tema = temasFormulario.find(t => t.id_Tema === pregunta.id_tema);
                                        setTemaSeleccionado(tema || null);
                                    }}
                                    onEliminar={async (id_pregunta) => {
                                        try {
                                            const preguntaEliminada = preguntasCompletas.find(p => p.id_pregunta === id_pregunta);

                                            setPreguntas(prev => prev.filter(p => p.id_pregunta !== id_pregunta));
                                            setPreguntasCompletas(prev => prev.filter(p => p.id_pregunta !== id_pregunta));

                                            // Remueve el círculo si sus coordenadas coinciden
                                            if (preguntaEliminada?.x != null && preguntaEliminada?.y != null) {
                                                setCircles(prev =>
                                                    prev.filter(c => c.x !== preguntaEliminada.x || c.y !== preguntaEliminada.y)
                                                );
                                            }

                                            // Borra el item de la matriz
                                            setItemsMatriz(prev => prev.filter(i => i.id !== id_pregunta));

                                            setCircleCoords(null);
                                            setIsLocked(false);
                                        } catch (err) {
                                            console.error('Error al eliminar pregunta:', err);
                                            Swal.fire({ icon: 'error', title: 'Error al eliminar la pregunta' });
                                        }
                                    }}
                                />
                            )}
                        </Paper>
                    </Grid>
                </Grid>

                {/* Modal para agregar item a la matriz */}
                <ModalMatriz open={openModalMatriz} onClose={() => {
                    setOpenModalMatriz(false);
                    setEditingItem(null); // Limpia edición cuando se cierra
                }} items={itemsMatriz} setItems={setItemsMatriz} tema={temaSeleccionado} editing={editingItem} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="contained">
                    Cerrar
                </Button>
                <Button onClick={handleSubmitFormulario} variant="contained" color="primary" startIcon={<SaveIcon />}>
                    Guardar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ModalAgregarPregunta;